export default {
    data: function(){
        return {
            content: this.model
        }
    },
    watch: {            
        model(val){
            if(JSON.stringify(this.model) != JSON.stringify(this.content)){
                this.content = this.model;
            }
        },
        content(val){
            this.$emit('update:model', val);
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/layout/mixin.js